module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-about-6ab8f5cbd17a052bbd6f438eac8b5b8f.jpg";